<template>
    <div class="fix-page">
        <div class="bg-yellow c-blue my-3 py-3">
            <div class="container-fluid">
                <div class="row ">
                    <div class="col">
                        <h2 class="today--heading">
                            <img class="today--heading--logo center-block" src="~__STATIC__/logo_valle_plus.svg" alt="Valle plus logo">
                            <span v-text="getTranslation('fixPageTitle')"></span>
                        </h2>
                    </div>
                </div>
            </div>
        </div>

        <banner></banner>

        <div class="d-md-block d-none">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="text-center pt-4" v-if="isLoading">
                            <icon-base :view-box-height="50"
                                       :view-box-width="50"
                                       :min-width="0"
                                       :min-height="0"
                                       :icon-color="'#166ba6'"
                                       :height="100"
                                       :width="100" :class="'align-bottom'">
                                <loading-icon/>
                            </icon-base>

                            <h5 class="c-blue text-bold" v-text="getTranslation('loadingFixTickets')"></h5>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 my-3" v-if="selectedFixEvent">
                        <fix-ticket-header :start-date="selectedFixEvent.date"></fix-ticket-header>
                        <product :increase="increase" :decrease="decrease" :data="product" v-for="product in selectedFixEvent.ticket.products" :key="product.key"></product>
                    </div>

                    <div class="col-12 col-md-8">
                        <calendar
                            :events="events"
                            :day-click="onDayClick"
                            :start-date="startDate"
                            :end-date="endDate"
                            :days="days">
                            <template slot="heading" slot-scope="props">
                                <button class="btn btn-link" v-if="props.hasPrevious" @click="props.previousMonth">
                                    <icon-base
                                        :view-box-height="512"
                                        :view-box-width="512"
                                        :width="30"
                                        :height="30"
                                        icon-color="#166ba6">
                                        <arrow-alt-circle-left-icon></arrow-alt-circle-left-icon>
                                    </icon-base>
                                </button>
                                <h3 class="calendar--monthly--header mb-3">{{ props.currentMonth && props.currentMonth.text }}</h3>
                                <button class="btn btn-link" v-if="props.hasNext" @click="props.nextMonth">
                                    <icon-base
                                        :view-box-height="512"
                                        :view-box-width="512"
                                        :width="30"
                                        :height="30"
                                        icon-color="#166ba6">
                                        <arrow-alt-circle-right-icon></arrow-alt-circle-right-icon>
                                    </icon-base>
                                </button>
                            </template>
                        </calendar>
                        <!-- <h4 class="my-3 mx-2" v-if="Object.keys(events).length == 0">
                        Tickets fecha fija no disponible por esta temporada. Compra tu ticket <a href="/flex">acá</a>
                        </h4> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="d-block d-md-none">
            <div class="container-fluid">
                <div class="row">
                    <div class="text-center py-4 col-12" v-if="isLoading">
                        <icon-base :view-box-height="50"
                                   :view-box-width="50"
                                   :min-width="0"
                                   :min-height="0"
                                   :icon-color="'#166ba6'"
                                   :height="30"
                                   :width="30" :class="'align-bottom'">
                            <loading-icon/>
                        </icon-base>

                        <h5 class="c-blue text-bold d-inline-block" v-text="getTranslation('loadingFixTickets')"></h5>
                    </div>

                    <div class="col-12">
                        <div v-for="month in Object.keys(eventsByMonth)" :key="month">
                            <h3 class="c-gray fix--ticket--month--header">{{ month }}</h3>
                            <fix-ticket
                                v-for="date in Object.keys(eventsByMonth[month])"
                                :data="eventFrom(month, date)"
                                :key="date"
                                :date="date"
                                :month="month"
                                :start-date="date"
                            ></fix-ticket>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {es} from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';
    import * as Actions from '../../store/action-types';
    import cartMixin from '../../mixins/cartMixin';
    import siteConfig from '../../mixins/siteConfig';

    export default {

        mixins: [cartMixin, siteConfig],

        data() {
            return {
                // daysCount: [1, 2, 3, 4, 5, 6, 7],
                daysCount: [1, 2],

                disabledDates: {
                    /**
                     * Only enable dates that has an associate event
                     *
                     * @param date
                     * @returns {boolean}
                     */
                    customPredictor: date => {
                        const dates = Array.from(Object.keys(this.events));
                        return !dates.some(d => d === moment(date).format('YYYY-MM-DD'));
                    }
                },
                days: [
                    this.getTranslation('mondayLabel'),
                    this.getTranslation('tuesdayLabel'),
                    this.getTranslation('wednesdayLabel'),
                    this.getTranslation('thursdayLabel'),
                    this.getTranslation('fridayLabel'),
                    this.getTranslation('saturdayLabel'),
                    this.getTranslation('sundayLabel')
                ],
                startDate: this.$store.state.startDate,
                endDate: this.$store.state.endDate,
                additionalDays: 90,
                es
            }
        },

        mounted() {
            const params = this.objectifyQueryString(window.location);
            if (params.nums) {
                this.$store.dispatch(Actions.setDaysQuantity, {daysQuantity: params.nums});
            }

            const {daysQuantity, startDate, endDate} = this.$store.state;
            this.$store.dispatch(Actions.getFixTicketsAndCart, {
                duration: daysQuantity, startDate, endDate
            });

            const stockDate = this.$store.state;
            this.$store.dispatch(Actions.getStockDates, {
                stockDate: stockDate
            })
        },

        computed: {
            isLoading() {
                return this.$store.state.loading;
            },

            events() {
                return this.$store.getters.events;
            },

            eventsByMonth() {
                return this.splitEventsInMonths(this.events);
            },

            selectedFixEvent() {
                return this.$store.state.selectedFixEvent && this.$store.state.selectedFixEvent.ticket
                    ? this.$store.state.selectedFixEvent
                    : undefined;
            },
            stockDate: {
                get() {
                    return this.$store.state.stockDate;
                },
                set(stockDate) {
                    this.$store.dispatch(Actions.setStockDates, {stockDate});
                }
            },

            daysQuantity: {
                get() {
                    return this.$store.state.daysQuantity;
                },

                set(daysQuantity) {
                    const {startDate, endDate} = this.$store.state;

                    Bus.$emit('unselect-calendar-day');
                    this.$store.dispatch(Actions.setDaysQuantity, {daysQuantity});
                    this.$store.dispatch(Actions.getFixTickets, {
                        duration: daysQuantity,
                        startDate,
                        endDate
                    });
                }
            }
        },

        methods: {
            active(quantity) {
                return this.daysQuantity >= quantity;
            },

            setDaysQuantity(quantity) {
                this.daysQuantity = quantity;
            },

            splitEventsInMonths(events) {
                let eventsByMonth = {};
                Object.keys(this.events).forEach(date => {
                    const month = moment(date).format('MMMM');
                    eventsByMonth[month] = eventsByMonth[month] || {};
                    eventsByMonth[month][date] = events[date];
                });
                return eventsByMonth;
            },

            logEventsByMonth(eventsByMonth) {
                Object.keys(eventsByMonth).forEach(month => {
                    console.group(`Month ${month}`);
                    Object.keys(eventsByMonth[month]).forEach(date => {
                        console.log(`${date}`, eventsByMonth[month][date]);
                    });
                    console.groupEnd();
                });
            },

            eventFrom(month, date) {
                return this.eventsByMonth[month][date];
            },

            onDayClick(day) {
                if (!day) return this.$store.dispatch(Actions.removeSelectedFixEvent);

                this.$store.dispatch(Actions.removeSelectedFixEvent);
                this.$store.dispatch(Actions.setSelectedFixEvent, {day});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Pages/FixPage.vue